GP.GPMod('MessagePane.Thread', /*{'what':'oook!'},*/ function(self) {
    //console.log(self.options.what);
    var vent  = null;
    var _util = null;

    // cost of priority message in credits
    var PRIORITY_MSG_COST = 100;

    // this flag prevents showing both msg_approach_pref and message_priority popups at the same time
    var show_priority_popup = true;

    var data = {
        init: function() {
            vent   = self.vent;
            _util = self.app.Util;

            // update cost for priority messages based on global js var from php constant in lib/var/user_credit.php
            if (window._priority_msg_credit_cost) {
                PRIORITY_MSG_COST = parseInt(window._priority_msg_credit_cost, 10);
            }
        },
        open_threads: {},
        max_open_threads: 3,
        preview_max_len: 25,
        overlay_width: 600,
        overlay_min_width: 300,
        default_right_pos: 246,
        docked_thread_width: 300,
        rdrawer_width: 320,
        fullscreen_mode: false,
        priority_helper_seen: false,
        add_open_thread: function(models) {
            this.open_threads[models.thread.id] = {
                // add the thread_id here just for quicker reference
                id: models.thread.id,
                thread_model: models.thread,
                user_model: models.user,
            };
        },
        init_metadata: function(thread_id, opened_from) {
            if (thread_id && this.open_threads[thread_id]) {
                this.open_threads[thread_id].thread_model.metadata = {
                    fetching_page: false,
                    first_page_reached: false,
                    last_page_reached: true,
                    // this used to save the location we are at in the thread before we load prev msgs
                    // so nanoscroller can scroll us back down after we add the prev msgs
                    bookmark: '',
                    min_msg_id: -1,
                    max_msg_id: 0,
                    typing_idle_timer: false,
                    opened_from: opened_from || ''
                };
            }
        },
        reset_metadata: function(thread_id) {
            if (thread_id && this.open_threads[thread_id]) {
                this.open_threads[thread_id].thread_model.metadata.first_page_reached = false;
                this.open_threads[thread_id].thread_model.metadata.last_page_reached = true;
                this.open_threads[thread_id].thread_model.metadata.bookmark = '';
                this.open_threads[thread_id].thread_model.metadata.min_msg_id = -1;
                this.open_threads[thread_id].thread_model.metadata.max_msg_id = 0;
                // this.open_threads[thread_id].thread_model.metadata.opened_from = '';
            }
        },
    };

    var gui = {
        init: function() {
            vent.on('MessagePane.'+self.moduleName+':position_threads', this.position_threads);

            this.set_max_open_threads();
            $(window).resize(_.debounce(gui.set_max_open_threads, 250));
        },
        position_threads: function() {
            if (MoshPit.get_size() == 'mobile') {
                $.each($('#message-thread-wrap .message-thread'), function(index, thread) {
                    // do not position full-view threads but still loop through them (so it leaves a space on the footer)
                    if (!$(thread).hasClass('docked')) {
                        // continue
                        return true;
                    }
                    var _thread_width = $('#message-thread-wrap .message-thread').width();
                    // +2 to both of these values for the space between threads
                    $(thread).css('right', (index * (_thread_width+2)));
                });
            } else {
                $.each($('#message-thread-wrap .message-thread'), function(index, thread) {
                    // do not position full-view threads but still loop through them (so it leaves a space on the footer)
                    if (!$(thread).hasClass('docked')) {
                        // continue
                        return true;
                    }
                    // +5 to both of these values for the space between threads
                    $(thread).css('right', (data.rdrawer_width+5) + (index * (data.docked_thread_width+5)));
                });
            }
        },
        set_max_open_threads: function() {

            // limit to 1 open thread at a time for specific whitelabels
            if (_util.check_limited_growls_host()) {
                data.max_open_threads = 1;
            } else {
                if (MoshPit.get_size() == 'mobile') {
                    data.max_open_threads = 2;

                    // close any unselected threads
                    $('#message-thread-wrap .message-thread').not('.selected').each(function() {
                        var thread_id = $(this).attr('id').split('-').pop();
                        vent.trigger('ThreadLayout.thread-'+thread_id+':close');
                    });
                } else {
                    data.max_open_threads = Math.floor(($(window).width() - data.rdrawer_width+5) / (data.docked_thread_width+5));
                }
            }
        }
    };

    var apis = {
        init: function() {
            vent.on('MessagePane.'+self.moduleName+':add_message', this.add_message);
            vent.on('MessagePane.'+self.moduleName+':get_thread', this.get_thread);
        },
        get_thread: function(thread_id, scroll_to_bottom = true, msg_id = null, order = "DESC") {
            // console.trace('MPT apis.get_thread called... thread_id: ', thread_id);
            // console.log('MPT apis.get_thread called... scroll_to_bottom: ', scroll_to_bottom);
            // console.log('MPT apis.get_thread called... msg_id: ', msg_id);
            // console.log('MPT apis.get_thread called... order: ', order);

            // reset it to true
            show_priority_popup = true;

            // tref = thread reference
            var tref = data.open_threads[thread_id];
            var my_user = GP.sdata.my_user;
            // console.log('get_thread tref: ', tref);

            if (typeof(tref) === 'undefined' || (tref.thread_model.metadata.fetching_page && order == "DESC")) {
                return;
            }

            let first_page = tref.thread_model.metadata.first_page_reached,
                msg_length = tref.thread_model.get('messages').length,
                total      = tref.thread_model.get('total'),
                fetch_messages = tref.thread_model.get('fetch_messages');

            let first_page_logic = (!first_page && (msg_length != total || fetch_messages));

            if (first_page_logic || order == "ASC") {

                let gt_input = {
                    duid: tref.thread_model.get('other_duid'),
                    min_msg_id: tref.thread_model.metadata.min_msg_id,
                    max_msg_id: null,
                    thread_order: order,
                    mv: (tref.thread_model.get('gold_initiated')) ? 1 : 0,
                    msg_id: msg_id,
                    languages: navigator.languages
                };

                if (order == "ASC") {
                    gt_input.max_msg_id = tref.thread_model.metadata.max_msg_id;
                }

                tref.thread_model.get('messages').fetch({
                    remove: false,
                    data: $.param(gt_input),
                    beforeSend: function() {
                        tref.thread_model.metadata.fetching_page = true;
                        vent.trigger('ThreadLayout.thread-'+thread_id+':show_loading_spinner');
                    }
                }).done(function(thread_data) {
                    // console.warn('MPT get_thread fetch done, thread_data: ', thread_data);

                    if (MoshPit.get_size() != 'mobile') {
                        vent.trigger('ThreadLayout.thread-'+thread_id+':hide_desktop_load_previous');
                        vent.trigger('ThreadLayout.thread-'+thread_id+':setup_observer');
                    }

                    let is_array = Array.isArray(thread_data);

                    // backbone Thread model has a prop/field "messages" which is a collection of Message models
                    // but has some useful meta data
                    var messages_collection = tref.thread_model.get('messages');

                    // NOTE: pretty sure this is no longer used
                    // msg_id 5 is a special BS msg_id for locked thread (i.e. exy user or other paid per thread etc)
                    if (thread_data && thread_data.length && thread_data[0].msg_id == 5) {
                        $('#thread-' + thread_id).addClass('noreply hide-private-vc');
                    }

                    if (thread_data && thread_data.length && messages_collection.claimable === true) {
                        if (messages_collection.claimed !== true) {
                            vent.trigger('ThreadLayout.thread-'+thread_id+':show_bronze_claimable');
                        }
                    }

                    if (!msg_id && order == "DESC") {
                        if (!is_array || thread_data.length < 20) {
                            tref.thread_model.metadata.first_page_reached = true;
                            vent.trigger('ThreadLayout.thread-'+thread_id+':hide_mobile_load_previous');
                        } /*else if (MoshPit.get_size() != 'mobile') {
                            // vent.trigger('ThreadLayout.thread-'+thread_id+':scroll_down');
                            vent.trigger('ThreadLayout.thread-'+thread_id+':hide_desktop_load_previous');
                            // vent.trigger('ThreadLayout.thread-'+thread_id+':show_desktop_load_previous');

                            // setTimeout(function() {
                            //     vent.trigger('ThreadLayout.thread-'+thread_id+':show_desktop_load_previous');
                            // }, 1000);
                        }*/
                    }

                    if (order == "ASC" || msg_id) {
                        tref.thread_model.metadata.last_page_reached = false;

                        if (!is_array || thread_data.length === 0) {
                            tref.thread_model.metadata.last_page_reached = true;
                            vent.trigger('ThreadLayout.thread-'+thread_id+':hide_mobile_load_next');
                        } else {
                            vent.trigger('ThreadLayout.thread-'+thread_id+':show_mobile_load_next');
                        }

                        if (msg_id) {
                            // add highlight/yellow background class
                            // that fades out after a few seconds
                            $('.thread-wrap #message_' + msg_id).addClass('fade-highlight');

                            // scroll to the highlighted message after a delay since img/video attachments
                            // may alter where the message is in the thread
                            setTimeout(function() {
                                vent.trigger('ThreadLayout.thread-'+thread_id+':scroll_to_msg', msg_id);
                            }, 500);
                        }
                    }

                    if (my_user.gender == 'WOMAN' && thread_data.length > 0 && messages_collection.replied === 0 && tref.user_model.id != 69) {
                            vent.trigger('ThreadLayout.thread-'+thread_id+':show_quick_reply');
                            if (thread_data.length <= 5) {
                                vent.trigger('ThreadLayout.thread-'+thread_id+':add_rude_user_msg');
                            }
                    }

                    if (messages_collection.length <= 1 && tref.user_model.id != 69) {
                        vent.trigger('ThreadLayout.thread-'+thread_id+':show_rude_warning');
                    }

                    if (_ai_chatbot_duids.includes(parseInt(tref.user_model.id,10))) {
                        vent.trigger('ThreadLayout.thread-'+thread_id+':show_ai_chatbot_notice');
                    }

                    tref.thread_model.metadata.min_msg_id = messages_collection.min_msg_id;
                    tref.thread_model.metadata.max_msg_id = messages_collection.max_msg_id;
                    tref.thread_model.metadata.fetching_page = false;

                    if (messages_collection.has_sent && !messages_collection.has_read_status) {
                        vent.trigger('ThreadLayout.thread-'+thread_id+':show_read_status_option');
                    }

                    if (my_user.membership == 'FREE' && thread_data.length > 0 && thread_data[0].duid != 69) {
                        events.set_mini_profile_sent_via({thread_id: thread_id});
                    }

                    // open msg_approach_pref popup if there are no messsages
                    // if (!thread_data.length) {
                    //     // flag to prevent priority popup
                    //     show_priority_popup = false;
                    //     vent.trigger('ThreadLayout.thread-'+thread_id+':show_msg_approach_pref', 10000);
                    // }

                    // var has_messages = !!thread_data.length;
                    // var cookie_chk   = $.cookie('msg_interests_auto_show');

                    // show_priority_popup = !has_messages;
                    // if (!cookie_chk || cookie_chk === 'yes') {
                    //     show_priority_popup = false;
                    // }
                    // vent.trigger('ThreadLayout.thread-'+thread_id+':handle_show_msg_interests_overlay', has_messages);

                    if (typeof tref.user_model.get('other_duid_max_content_rating') !== 'undefined') {
                        // setting from user.profile module
                        tref.thread_model.metadata.other_duid_max_content_rating = tref.user_model.get('other_duid_max_content_rating');
                    } else if (typeof thread_data[0] !== 'undefined' && typeof thread_data[0].other_duid_max_content_rating !== 'undefined') {
                        // setting from msg.get_thread module
                        tref.thread_model.metadata.other_duid_max_content_rating = thread_data[0].other_duid_max_content_rating;
                    } else {
                        // default to rated "X"
                        tref.thread_model.metadata.other_duid_max_content_rating = 'X';
                    }

                    if (typeof thread_data[0] !== 'undefined' && typeof thread_data[0].other_duid_native_app_reg !== 'undefined') {
                        tref.thread_model.metadata.other_duid_native_app_reg = thread_data[0].other_duid_native_app_reg;
                    }

                    return thread_data;
                }).always(function() {
                    vent.trigger('ThreadLayout.thread-'+thread_id+':hide_loading_spinner');
                    util.handle_priority_msg_helpers(thread_id, show_priority_popup);

                    // scroll thread to bottom after a delay
                    if (scroll_to_bottom) {
                        setTimeout(() => {
                            vent.trigger('ThreadLayout.thread-'+thread_id+':scroll_bottom');
                        }, 1000);
                    }
                });
            } else {
                if (my_user.membership == 'FREE' && tref.thread_model.get('other_duid') != 69) {
                    events.set_mini_profile_sent_via({ thread_id: thread_id });
                }
                tref.thread_model.metadata.min_msg_id = tref.thread_model.get('messages').min_msg_id;
                tref.thread_model.metadata.max_msg_id = tref.thread_model.get('messages').max_msg_id;

                util.handle_priority_msg_helpers(thread_id, show_priority_popup);
                return tref.thread_model.get('messages');
            }
        },
        add_message: function(msg_obj, obj_scope, error_cb) {
            if (GP.sdata.is_mobile || GP.sdata.is_tablet) {
                msg_obj.tags_array.push('MOBILE');
            }

            var thread_id = msg_obj.thread_id;

            var message_model_attrs = {
                to_duid: msg_obj.to_duid,
                message: msg_obj.message,
                tag: msg_obj.tags_array,
                direction: 'sender',
                sender_duid: GP.sdata.my_user.duid,
                msg_system_id: null,
                mtime: new Date().toLocalISOString(),
                pic: GP.sdata.my_user.pic
            };

            var messages_collection = data.open_threads[thread_id].thread_model.get('messages');

            // remove the special msg_id of 3 (sent msg priority) in case it exists
            // since it will get added again if needed after adding msg to the thread
            messages_collection.remove(3);

            if (messages_collection.claimable === true) {
                message_model_attrs.claimable = true;
            }

            if (msg_obj.is_priority_guarantee_reply === true) {
                message_model_attrs.is_priority_guarantee_reply = true;
            }

            if (msg_obj.mpg_nc === true) {
                message_model_attrs.mpg_nc = true;
            }

            if (msg_obj.has_read_status) {
                // mark the message unread if user has purchased READ STATUS
                message_model_attrs.has_read_status = msg_obj.has_read_status;
                message_model_attrs.other_unread = 1;
            } else {
                vent.trigger('ThreadLayout.thread-'+msg_obj.thread_id+':show_read_status_option');
            }

            var new_message = new GP.models.Message(message_model_attrs);

            // save this model to the server (attachments are already saved to the server)
            if (!_.contains(msg_obj.tags_array, 'ATTACHMENT') && !_.contains(msg_obj.tags_array, 'VIDEO_ATTACHMENT') && !_.contains(msg_obj.tags_array, 'AUDIO_ATTACHMENT') && !_.contains(msg_obj.tags_array, 'PREMIUM_ATTACHMENT') && !_.contains(msg_obj.tags_array, 'PREMIUM_VIDEO_ATTACHMENT')) {
                new_message.save(null, {
                    success: function(model, response) {
                        var error = model.get('error');

                        // auto trigger modal if link is returned
                        if (response && response.hasOwnProperty('modal_link')) {
                            GP.vent.trigger('Modal:open', {
                                url:  response.modal_link,
                                duid: msg_obj.to_duid
                            });

                            return;
                        }

                        // if we have an error, either set the error in the model, or call the callback if provided
                        if (error && error.length) {
                            var trial_user = GP.sdata.my_user.unconverted_trial;

                            // show link in notification/alert to upgrade trial for unconverted trial users
                            if (trial_user && error[0] === 'new message limit reached') {

                                // auto trigger upgrade modal, and add click to notification
                                GP.vent.trigger('Modal:open', {
                                    url: "/members/billing/trial_upgrade_modal/",
                                });
                                var $ug_link = $('<div/>')
                                    .html('<p>Oops, you reached the daily limit.</p><b>Upgrade here</b> to send unlimited messages')
                                    .addClass('no-follow')
                                    .one('click', function(e) {
                                        e.preventDefault();

                                        var $nb    = $(e.target).parents('.notification-body'),
                                            $close = $nb.siblings('.close');

                                        GP.vent.trigger('Modal:open', {
                                            url: "/members/billing/trial_upgrade_modal/",
                                        });

                                        setTimeout(function() {
                                            $close.click();
                                        }, 5000);
                                    }
                                );

                                vent.trigger('ThreadLayout.thread-'+msg_obj.thread_id+':show_notification', 'danger', null, $ug_link);

                                return;
                            }

                            if (typeof error_cb == 'function') {
                                error_cb.call((obj_scope || this), error[0]);

                                return false;
                            } else {
                                model.set('error', error[0]);
                            }
                        }

                        // if (response.hasOwnProperty('credits_claimed') && response.credits_claimed === true) {
                        let claim_chk = response?.credits_claimed || response?.claimed == 'NC';
                        if (claim_chk) {
                            // console.warn('MPT credits claimed, remove msg');

                            // remove special msg_id of 6 which informs the user they can claim credits
                            messages_collection.remove(6);

                            // update collection data so it's claimed
                            messages_collection.claimable = false;
                            messages_collection.claimed = true;
                            messages_collection.claim_days_left = 0;

                            // show message that informs user they claimed credits for replying and then remove
                            if (response?.credits_claimed) {
                                vent.trigger('ThreadLayout.thread-'+thread_id+':show_bronze_claimed', response.user_updated_credits);
                            }

                        }

                        // add to thread but escape message text
                        var new_msg = $.extend({}, msg_obj, message_model_attrs);
                        new_msg.message = _.escape(new_msg.message);
                        model.set('message', new_msg.message);

                        util.add_message_to_thread(new_msg, model);
                    },
                    error: function(model, response) {
                        var error_msg = 'something went wrong';

                        if (response && response.error) {
                            error_msg = response.error[0];
                        }

                        // TODO: didn't work, roll back
                        var tref = data.open_threads[msg_obj.thread_id];

                        if (typeof error_cb == 'function') {
                            error_cb.call((obj_scope || this), error_msg);
                            return false;
                        } else {
                            model.set('error', error_msg);
                            tref.thread_model.get('messages').add(model);
                        }
                    }
                });
            } else {
                // attachments have already been saved to the server so they have a msg_id
                new_message.set({ 'msg_id' : msg_obj.msg_id });

                if (msg_obj.attachment_url) {
                    new_message.set({ 'attachment_url' : msg_obj.attachment_url });
                }
                if (msg_obj.attachment_html) {
                    new_message.set({ 'attachment_html' : msg_obj.attachment_html });
                }
                if (msg_obj.attachment_info) {
                    new_message.set({ 'attachment_info' : msg_obj.attachment_info });
                }
                if (msg_obj.attachment_purchased) {
                    new_message.set({ 'attachment_purchased' : msg_obj.attachment_purchased });
                }

                var new_msg_obj = $.extend({}, msg_obj, message_model_attrs);
                try {
                    util.add_message_to_thread(new_msg_obj, new_message);
                } catch (e) {
                    if (typeof Sentry != 'undefined') {
                        Sentry.captureException(e, {
                            extra: {
                                msg_ob:      msg_obj,
                                new_msg_ob:  new_msg_obj,
                                msg_mod_att: message_model_attrs
                            }
                        });
                    }
                }
            }
        },
        upgrade_sent_msg_to_priority: function(obj) {
            // call web module via ajax to deduct credits and apply PRIORITY tag to msg_id
            var api_data = {
                ajax_request: true,
                to_duid:   obj.to_duid,
                msg_id:    obj.msg_id,
                thread_id: obj.thread_id,
                product_type: obj.product_type
            };
            self.api.json('msg.add_priority', {
                data:    api_data,
                success: function(json) {
                    if (typeof json != 'undefined' && json && json.thread_id && json.msg_id) {
                        vent.trigger('ThreadLayout.thread-'+json.thread_id+':hide_sent_msg_priority');

                        var tags = data.open_threads[json.thread_id].thread_model.get('messages').get(json.msg_id).get('tag');
                        vent.trigger('ThreadLayout.thread-'+json.thread_id+':add_priority_tag', json.msg_id, tags);

                        var $success_container = $('.modal .alert-success');
                        $success_container.removeClass('hide');
                        setTimeout(function() {
                            $success_container.addClass('hide');
                        }, 3000);
                    } else {
                        var error = (json && json.error) ? json.error : js_lang.server_error;
                        vent.trigger('ThreadLayout.thread-'+obj.thread_id+':show_notification', 'danger', error);

                        var $error_container = $('.modal .alert-danger');
                        $error_container.find('p').remove();

                        $error_container.append('<p class="error">'+error+'</p>');
                        $error_container.removeClass('hide');
                    }
                },
                error:   function(jqXHR, status, error) {
                    vent.trigger('ThreadLayout.thread-'+obj.thread_id+':show_notification', 'danger', js_lang.server_error);
                }
            });
        },
        upgrade_priority_success: function() {

        },
        upgrade_priority_error: function(json) {
        }
    };

    var util = {
        add_message_to_thread: function(msg_obj, model, retry) {
            var tref = data.open_threads[msg_obj.thread_id];

            // if we don't have this thread in our open_threads obj like we should try to grab
            // the thread_json (which has the data we need) if it's not a retry (recursion protection)
            if (!tref && !retry) {
                var to_duid  = parseInt(msg_obj.to_duid, 10);
                var tmp_user = new GP.models.User({duid: to_duid});

                tmp_user.thread_json()
                .done(function(thread_json) {
                    if (GP.Util.check_obj(thread_json)) {
                        var user   = thread_json.users[0];
                        var thread = thread_json.threads[0];

                        // bail if we don't have the user/thread objects we were after
                        if (!_.isObject(user) || !_.isObject(thread)) {
                            return;
                        }

                        // add user
                        GP.sdata.MessagingUsers.add(user);

                        // add thread
                        GP.sdata.MessagingThreads.add(thread);

                        // add to our open threads
                        data.add_open_thread({
                            user:   GP.sdata.MessagingUsers.get(user.duid),
                            thread: GP.sdata.MessagingThreads.get(thread.thread_id)
                        });
                        data.init_metadata(thread.thread_id);

                        // after we've added the thread/user models to data.open_threads
                        // and initialized metadata call add_message_to_thread again so the
                        // data will be there. we add true for 3rd param "retry" so we only retry once
                        // and won't recurse indefinitely if it fails again for some dumb reason
                        util.add_message_to_thread(msg_obj, model, true);
                    }
                }).fail(function() {
                    // send error report to sentry on fail maybe?
                });

                // return from the first call to add_message_to_thread because we didn't have the data we needed
                // the done() callback to the user model's thread_json will call add_message_to_thread again
                return false;
            }

            tref.thread_model.get('messages').add(model);

            // update the threads collection (which updates the inbox UI)
            var message_preview = '';
            // the marionette view handles message_preview for attachments
            if (!_.contains(msg_obj.tag, 'ATTACHMENT') || !_.contains(msg_obj.tag, 'VIDEO_ATTACHMENT') || !_.contains(msg_obj.tag, 'AUDIO_ATTACHMENT') || !_.contains(msg_obj.tag, 'PREMIUM_ATTACHMENT') || !_.contains(msg_obj.tag, 'PREMIUM_VIDEO_ATTACHMENT')) {
                var unescaped_string = _.unescape(msg_obj.message);
                var processed_string = (unescaped_string.length > data.preview_max_len) ? unescaped_string.substring(0, data.preview_max_len-3)+'...' : unescaped_string;
                message_preview = _.escape(processed_string);
            }
            var thread_model_attrs = {
                'message' : message_preview,
                'tag'     : msg_obj.tag,
                'msg_id'  : model.get('msg_id'), //parseInt(tref.thread_model.get('msg_id'),10) + 1,
                'total'   : parseInt(tref.thread_model.get('total'),10) + 1,
                'ctime'   : msg_obj.mtime,
                'sender_duid' : GP.sdata.my_user.duid
            };
            tref.thread_model.set(thread_model_attrs);
            tref.thread_model.metadata.max_msg_id = model.get('msg_id');
            vent.trigger('MessagePane.Inbox:add_selected', tref.thread_model.id);

            // run through the priority_msg_helper logic to put sent_msg_priority helper if applicable
            // vent.trigger('ThreadLayout.thread-'+tref.thread_model.id+':hide_priority_msg');
            util.handle_priority_msg_helpers(tref.thread_model.id, show_priority_popup);

            vent.trigger('ThreadLayout.thread-'+tref.thread_model.id+':scroll_bottom');
        },
        // determine which (if any) priority message helpers should be shown/applied
        handle_priority_msg_helpers: function(thread_id, show_priority_message_popup) {
            if (typeof thread_id != 'undefined' && thread_id && data.open_threads[thread_id]) {
                var tref        = data.open_threads[thread_id];
                var my_user     = GP.sdata.my_user;
                var messages    = tref.thread_model.get('messages'); // messages collection inside thread model
                var min_msg_id  = messages.min_msg_id;
                var max_msg_id  = messages.max_msg_id;
                var new_thread  = (min_msg_id === 0 && max_msg_id === 0) ? true : false;
                var has_replies = (messages.other_user_replied) ? true : false;
                // var timeout     = has_replies ? 6000 : 10000;
                var timeout     = 4000;
                var last_model  = ((!new_thread) ? messages.get(max_msg_id) : false);

                var last_read_msg_id      = NaN;
                var last_msg_is_from_user = false;
                var last_msg_priority     = false;
                let is_deleted                     = last_model && _.contains(last_model.get('tag'), "DELETED");

                if (last_model && last_model.get('direction') == 'sender' && last_model.get('msg_id') == max_msg_id) {
                    last_msg_is_from_user = tref.thread_model.metadata.last_msg_is_from_user = true;

                    var priority      = _.contains(last_model.get('tag'), "PRIORITY");
                    last_msg_priority = tref.thread_model.metadata.last_msg_priority = priority;
                    last_read_msg_id  = parseInt(last_model.get('other_user_last_read_msg_id'), 10);
                }

                // show the priority message helper for non free men if we haven't seen it yet
                if (my_user.gender == 'MAN' && my_user.membership != 'FREE' && tref.user_model.id != 69 && !is_deleted) {
                    if (my_user.can_oneclick || my_user.credits > 0) {
                        var priority_class = 'new-thread';

                        var other_user_viewed = (_.isFinite(last_read_msg_id) && last_read_msg_id == max_msg_id);
                        if (!new_thread && has_replies) {
                            priority_class = 'has-replies';
                        } else if (!new_thread && !has_replies) {
                            priority_class = 'no-replies';
                        }

                        // show promote last sent message to priority for men if the most recent message if from the user
                        // and isn't already tagged priority, and hasn't been read/viewed by the other user
                        if (last_msg_is_from_user && !last_msg_priority && !other_user_viewed) {
                            // trigger the promote last sent message to priority helper
                            vent.trigger('ThreadLayout.thread-'+thread_id+':show_sent_msg_priority');
                        } else if (show_priority_message_popup) {
                            vent.trigger('ThreadLayout.thread-'+thread_id+':show_priority_msg', priority_class, timeout);
                        }
                    }
                }
            }
        },
        mod_thread_msg: function(msg_data) {
            let tref                = data.open_threads[msg_data.thread_id];
            let messages_collection = tref.thread_model.get('messages');
            let model_to_update     = messages_collection.findWhere({msg_id: msg_data.msg_id});
            let tags                = [];

            // update client side message and tag
            if (msg_data.tag) {
                tags = model_to_update.get('tag');

                if (msg_data.tag === 'DELETED') {
                    // remove all tags except DELETED
                    tags = [msg_data.tag];
                    model_to_update.set("emoji", '');
                } else {
                    tags.push(msg_data.tag);
                }

                model_to_update.set("tag", tags);
            }

            if (msg_data.message) {
                model_to_update.set("message", msg_data.message);
            }
            if (msg_data.emoji) {
                model_to_update.set("emoji", msg_data.emoji);
            }

            // update inbox UI
            if (tref.thread_model.get('msg_id') === msg_data.msg_id) {
                if (msg_data.tag) {
                    tref.thread_model.set("tag", tags);
                }

                if (msg_data.message) {
                    tref.thread_model.set("message", msg_data.message);
                }
            }
        },
        remove_priority_msg_item: function(msg_data) {
            let tref = data.open_threads[msg_data.thread_id];
            let messages_collection = tref.thread_model.get('messages');
            messages_collection.remove(3);
        }
    };

    var events = {
        init: function() {
            vent.on('MessagePane.'+self.moduleName+':create_thread', this.create_thread);
            vent.on('MessagePane.'+self.moduleName+':reset_thread', this.reset_thread);
            vent.on('MessagePane.'+self.moduleName+':close_thread', this.close_thread);
            vent.on('MessagePane.'+self.moduleName+':set_max_msg_id', this.set_max_msg_id);
            vent.on('MessagePane.'+self.moduleName+':set_mini_profile_sent_via', this.set_mini_profile_sent_via);

            vent.on('MessagePane.'+self.moduleName+':set_sent_msg_priority', this.set_sent_msg_priority);

            GP.reqres.setHandler('MessagePane.'+self.moduleName+':get_open_threads', this.get_open_threads);
            GP.reqres.setHandler('MessagePane.'+self.moduleName+':maximized', function() {
                return $('body').hasClass('message-thread-maximized');
            });

            vent.on('MessagePane.'+self.moduleName+':mod_thread_msg', util.mod_thread_msg);
            vent.on('MessagePane.'+self.moduleName+':remove_priority_msg_item', util.remove_priority_msg_item);

        },
        create_thread: function(models, from_pop_state, opened_from, msg_id) {
            // console.trace('(MPT) create_thread, models: ', models);
            // console.log('(MPT) create_thread, from_pop_state: ', from_pop_state);
            // console.log('(MPT) create_thread, opened_from: ', opened_from);
            // console.log('(MPT) create_thread, msg_id: ', msg_id);

            if (!data.open_threads[models.thread.id]) {
                data.add_open_thread(models);
            }
            var tref = data.open_threads[models.thread.id];
            if (!tref.thread_model.metadata) {
                data.init_metadata(tref.id, opened_from);
            }

            var tag = tref.thread_model.get('tag');
            var poke = (_.contains(tag, 'POKE')) ? true : false;
            var ice_breaker = (_.contains(tag, 'ICE_BREAKER')) ? true : false;

            // thread doesn't already exist on the page, create it
            if (!tref.layout) {
                var open_threads = $('#message-thread-wrap .message-thread');
                if (open_threads.length >= data.max_open_threads) {
                    // remove the oldest thread to make room for this one
                    open_threads.eq(0).find('.close').trigger('click');
                }

                // thread-layout
                tref.layout = new self.app.views.ThreadLayout({
                    id: 'thread-'+tref.id,
                    thread: models.thread,
                    user: models.user,
                });
                // the order of the next 2 lines matter because of bindUIElements() which happens in render()
                $('#message-thread-wrap').append(tref.layout.el);
                tref.layout.render();

                // mini-profile
                var mini_profile = new self.app.views.ThreadMiniProfile({
                    id: 'thread-mini-profile-'+tref.id,
                    model: models.user,
                    thread_id: tref.id,
                });
                tref.layout.mini_profile.show(mini_profile);

                // messages-list
                data.reset_metadata(tref.id);
                if (
                    GP.sdata.my_user.membership == 'FREE'
                    && MoshPit.get_size() == 'mobile'
                    && models.user.get('duid') != 69
                    && !_ai_chatbot_duids.includes(parseInt(models.user.get('duid'),10))
                ) {
                    events.set_mini_profile_sent_via_mobile({thread_id: tref.id});
                } else {
                    apis.get_thread(tref.id, false, msg_id);
                }

                let ml_options = {
                    collection: tref.thread_model.get('messages'),
                    thread_id: tref.id
                };

                if (msg_id) {
                    ml_options.open_to_msg_id = msg_id;
                }

                var messages_list = new self.app.views.MessagesList(ml_options);

                tref.layout.thread.show(messages_list);

                // change thread to maximixed view, default view when created is docked mode
                // thread_model.thread_style overrides thread_style message pref (for opening docked threads from the friend pane)
                // free users will always open threads as docked & have no option to change it (the options are hidden)
                // if (tref.thread_model.get('thread_style') != 'docked' && GP.sdata.thread_style != 2 && GP.sdata.my_user.membership != 'FREE') {
                //     vent.trigger('ThreadLayout.thread-'+tref.id+':maximize');
                // }
                // docked = 2
                // maximized = 1

                var from_sm      = models.user.get('duid') == 69 ? true : false, // site master
                    thread_style = tref.thread_model.get('thread_style'), // current thread style
                    msg_perf_ts  = GP.sdata.thread_style, // thread style from msg preferences
                    membership   = GP.sdata.my_user.membership,
                    from_ai_chatbot = _ai_chatbot_duids.includes(parseInt(models.user.get('duid'),10));

                if (from_sm || from_ai_chatbot || (thread_style != 'docked' && msg_perf_ts != 2 && membership != 'FREE') ) {
                    vent.trigger('ThreadLayout.thread-'+tref.id+':maximize', {force: from_sm});
                }
                gui.position_threads();

            } else {
                // thread is already on the page, just set it selected (mobile will never have more than 1 thread open at once)
                if (MoshPit.get_size() != 'mobile') {
                    if (tref.layout.$el.hasClass('minimized')) {
                        vent.trigger('ThreadLayout.thread-'+tref.id+':maximize');
                    } else {
                        vent.trigger('ThreadLayout.thread-'+tref.id+':set_selected');
                    }
                }
            }

            if (!from_pop_state && window.history && window.history.pushState) {
                if (!window.history.state || !window.history.state.hasOwnProperty('thread')) {
                    if (models && models.thread) {
                        var tmp_thread = models.thread.toJSON();
                        var state_obj = {
                            thread_open: {
                                duid:      tmp_thread.other_duid,
                                thread_id: tmp_thread.thread_id
                            }
                        };
                        vent.trigger("Page:push_state", state_obj);
                    }
                }
            }
        },
        reset_thread: function(thread_id) {
            // clear out messages & reload the current thread
            var tref = data.open_threads[thread_id];
            tref.thread_model.get('messages').reset_metadata();
            tref.thread_model.get('messages').reset();
            data.reset_metadata(tref.id);
            apis.get_thread(tref.id);
        },
        close_thread: function(thread_id) {
            if (data.open_threads[thread_id]) {
                // remove thread from inbox if there are zero messages
                if (parseInt(data.open_threads[thread_id].thread_model.get('total'),10) === 0) {
                    self.sdata.MessagingThreads.remove(thread_id);
                }
                data.open_threads[thread_id] = null;
                gui.position_threads();
            }
        },
        set_max_msg_id: function(obj) {
            // used when we recieve a msg from comet in a thread thats open
            var tref = data.open_threads[obj.thread_id];
            if (tref) {
                tref.thread_model.metadata.max_msg_id = obj.msg_id;
            }
        },
        get_open_threads: function() {
            var threads_ar = [];
            for (var thread_id in data.open_threads) {
                if (data.open_threads[thread_id]) {
                    threads_ar.push(thread_id);
                }
            }
            // no idea why _.each(data.open_threads, function(thread, thread_id) wouldn't iterate...
            return threads_ar;
        },
        set_mini_profile_sent_via_mobile: function(obj) {
            if (typeof obj == 'undefined' || !obj) {
                return;
            }
            var sent_via = 'web';
            var _current_thread = GP.sdata.MessagingThreads.get(obj.thread_id);

            if (_.contains(_current_thread.get('tag'), 'ICE_BREAKER') || _.contains(_current_thread.get('tag'), 'POKE')) {
                sent_via = 'ice_breaker';
            } else if (_.contains(_current_thread.get('tag'), 'WYWA')) {
                sent_via = 'wywa';
            } else if (_.contains(_current_thread.get('tag'), 'MOBILE')) {
                sent_via = 'mobile';
            }

            vent.trigger('ThreadMiniProfile.'+obj.thread_id+':show_sent_via', { sent_via: sent_via });
        },
        set_mini_profile_sent_via: function(obj) {
            if (typeof obj == 'undefined' || !obj) {
                return;
            }
            var tref = data.open_threads[obj.thread_id];

            if (tref && tref.thread_model) {
                // the order matters here
                var sent_via = 'web';
                if (tref.thread_model.get('messages').is_wywa) {
                    sent_via = 'wywa';
                } else if (tref.thread_model.get('messages').is_mpf) {
                    sent_via = 'mpf';
                } else if (tref.thread_model.get('messages').is_mobile) {
                    sent_via = 'mobile';
                } else if (tref.thread_model.get('messages').is_ice_breaker) {
                    sent_via = 'ice_breaker';
                }
                vent.trigger('ThreadMiniProfile.'+obj.thread_id+':show_sent_via', { sent_via: sent_via });
            }
        },
        set_sent_msg_priority: function(obj) {
            if (typeof obj != 'undefined' && obj && obj.thread_id) {
                // try to apply priority tag to last sent message from user (if no reply)
                var tref         = data.open_threads[obj.thread_id];
                var thread_id    = tref.id;
                var msg_id       = tref.thread_model.metadata.max_msg_id;
                var to_duid      = parseInt(tref.user_model.get('duid'), 10);
                var my_user      = GP.sdata.my_user;
                var credits      = parseInt(my_user.credits, 10);
                var user_check   = (my_user.gender == 'MAN' && my_user.membership != 'FREE');
                var can_purchase = (my_user.can_oneclick || credits > 0);

                // other user hasn't replied to user's last sent message (i.e. newest msg is from user)
                var newest_msg_from_user = !!tref.thread_model.metadata.last_msg_is_from_user;

                var cm_input = {
                    template: 'SENT_MSG_PRIORITY',
                    other_duid: to_duid,
                    thread_id: thread_id,
                    // close_delay: 3000,
                    confirm_priority: (obj.toggle_only != 'undefined' && obj.toggle_only) ? 1 : 0
                };
                vent.trigger('Modal:open:confirm', cm_input, function() {
                    let _priority_input = document.querySelector('.priority-msg-product:checked');
                    let _priority_type = _priority_input.value;
                    let _price = PRIORITY_MSG_COST;

                    if (_priority_type === 'PRIORITY_GUARANTEE') {
                        _price = parseInt(window._priority_msg_guarantee_credit_cost, 10);
                    }

                    if (obj.toggle_only != 'undefined' && obj.toggle_only) {
                        // turn on priority messaging, but don't send yet.
                        // this sets the priority type in the thread-layout template
                        vent.trigger('ThreadLayout.thread-'+thread_id+':set_priority_input', _priority_type);
                    } else if (user_check && newest_msg_from_user && can_purchase) {
                        if (credits >= _price) {

                            // call module via ajax and display success/failure
                            apis.upgrade_sent_msg_to_priority({
                                to_duid:   to_duid,
                                thread_id: thread_id,
                                msg_id:    msg_id,
                                product_type: _priority_type
                            });
                        } else {
                            // open credits modal and purchase apply purchase on success

                            // bind to custom event that the iframe success template will trigger
                            $('body').one('fl_credits_purchased', function(e) {
                                // if this is called, we don't need to use the fl_modal_closed event
                                $(document).off('fl_modal_closed');

                                // give the PB some time to update the DB and fire the mod_user_credits cometd message
                                // which should update the user's shared data (sdata)
                                setTimeout(function() {
                                    // if we have credits now, call api to promote msg to priority
                                    if (GP.sdata.my_user.credits >= _price) {
                                        GP.vent.trigger('Modal:close');

                                        apis.upgrade_sent_msg_to_priority({
                                            to_duid:   to_duid,
                                            thread_id: thread_id,
                                            msg_id:    msg_id,
                                            product_type: _priority_input.value
                                        });
                                    } else {
                                        // self.check_credits(self);
                                    }
                                }, 2000);
                            });

                            // trigger modal to purchase credits if one click is available, or redirect to billing
                            if (GP.sdata.my_user.can_oneclick) {
                                vent.trigger('Modal:open', {
                                    url: "/members/billing/credit_modal/",
                                });
                            } else {
                                window.location.href = GP.Util.clean_url('/members/billing/add_credits/?unlock=msg_priority&pduid='+to_duid);
                            }
                        }
                    }
                });
            }
        }
    };

    this.addInitializer(function() {
        data.init();
        gui.init();
        apis.init();
        events.init();
    });
});

